import { accountApi } from "../../config/apiConfig";
import { EmailPreview, EmailPreviewType } from "../../types/onboarding";

// POST /admin/prospects/{id}/email-preview (acc-management CWA-173). Read-only:
// no email is sent and no state changes. A precondition the real send would
// refuse is refused here with the same status, so the send's own error mapper
// words it. station_ids only matters for GO_LIVE, where it decides which
// stations the email names — the same meaning as on go-live itself.
export const previewEmail = async (
  id: string,
  type: EmailPreviewType,
  stationIds?: string[]
): Promise<EmailPreview> => {
  const response = await accountApi.post(
    `admin/prospects/${id}/email-preview`,
    stationIds?.length ? { type, station_ids: stationIds } : { type }
  );
  return response.data;
};
